__turbopack_context__.v({
  "className": "eTYqVW_className",
  "variable": "eTYqVW_variable",
});
